import React from "react";
import Divider, { DividerProps } from "@mui/material/Divider";

// New styling etc can be found with the material-next if ever wanted
// import Divider from '@mui/material-next/Divider';

export type WcDividerProps = DividerProps & {
  variant?: string;
  textAlign?: string;
  orientation?: string;
};

export const WcDivider = ({
  variant,
  textAlign,
  orientation,
  ...props
}: WcDividerProps) => (
  <Divider
    variant={variant}
    textAlign={textAlign}
    orientation={orientation}
    {...props}
  ></Divider>
);

export default WcDivider;
